import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsConvertioComponent } from './simple-icons-convertio.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsConvertioComponent ],
    exports:      [ SimpleIconsConvertioComponent ],
    bootstrap:    []
})
export class SimpleIconsConvertioModule {}
